module.exports = __webpack_public_path__ + "img/apps_12.a1eadc45.jpg";